module.exports = __webpack_public_path__ + "img/logo01.423c7411.webp";